import React, { Component } from 'react';
import { connect } from 'react-redux';
import styles from './RenderView.module.css';
import propTypes from 'prop-types';
import RenderReview from '../../components/RenderReview';
import Modal from 'react-modal';
import {
  getJob,
  exportImage,
  getResults,
  getJobResults,
  getNumbers,
  uploadScene7,
  deleteJob,
} from '../../modules/jobs';
import Button from '../../components/Button';
import moment from 'moment';
import Carousel from '../../components/Carousel';
import Waypoint from 'react-waypoint';

const customStyles = {
  content: {
    top: '35%',
    left: '50%',
    width: '500px',
    right: 'auto',
    bottom: 'auto',
    border: '1px solid grey',
    padding: '20px',
    borderRadius: 0,
    transform: 'translate(-50%, -50%)',
  },
};

class RenderView extends Component {
  state = { displayType: 'list', modalOpen: false };
  static contextTypes = {
    router: propTypes.object,
  };

  async componentDidMount() {
    const { getJob, getJobResults } = this.props;
    const { router } = this.context;
    const { id } = router.route.match.params;
    const render = await getJob(id);
    await getJobResults(id);
    this.setState({ render });
  }

  downloadImages = async () => {
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { exportImage } = this.props;
    const result = await exportImage(id);
    if (result) {
      console.log('DOWNLOAD FAILED.........');
      console.log(result);
    }
  };
  deleteJob = async () => {
    const { router } = this.context;
    const { id } = router.route.match.params;
    const { deleteJob } = this.props;
    const result = await deleteJob(id);
    router.history.push('/renderings');
  };

  loadMoreResults = async page => {
    const { getJobResults } = this.props;
    const { router } = this.context;
    const { id } = router.route.match.params;
    await getJobResults(id, { page });
  };

  updateDisplayType = () => {
    const { displayType } = this.state;
    const newType = displayType === 'list' ? 'carousel' : 'list';
    this.setState({ displayType: newType });
  };

  submitUploadJob = async () => {
    const { uploadScene7 } = this.props;
    const { router } = this.context;
    const { id } = router.route.match.params;
    const result = await uploadScene7(id);
    router.history.push('/renderings');
  };

  closeModal = () => {
    this.setState({ modalOpen: false, scene7upload: false });
  };

  render() {
    const { render, displayType, modalOpen } = this.state;
    const { results, number } = this.props;
    if (!render || (!results && !render.results)) return null;
    const images = results.length > 0 ? results : render.results;
    return (
      <div className={styles.container}>
        <div className={styles.header}>{render.name}</div>
        <div className={styles.statsContainer}>
          <div className={styles.actionContainer}>
            <div>
              <Button
                text="Download All Images (.zip)"
                onClick={this.downloadImages}
              />
              <Button
                style={{ marginLeft: 20 }}
                text={
                  render.renderType === 'sectional'
                    ? 'Upload Sectional Configurator'
                    : 'Upload to Scene7'
                }
                onClick={e =>
                  this.setState({ modalOpen: true, scene7upload: true })
                }
              />
              <Button
                style={{ marginLeft: 20 }}
                text="Delete Render Job"
                onClick={this.deleteJob}
              />
            </div>
            <div className={styles.displayType}>
              <img
                src={`/img/${displayType}.png`}
                onClick={this.updateDisplayType}
              />
            </div>
          </div>
          <div className={styles.stats}>
            <p className={styles.statsKey}>{number} images </p>
            <p className={styles.statsDivider}> |</p>
            <p className={styles.statsKey}>
              Job Started:{' '}
              <span className={styles.statsValue}>
                {moment(render.createdAt).format('YYYY-MM-DD HH:mm:ss')}
              </span>{' '}
            </p>
            <p className={styles.statsDivider}> |</p>

            <p className={styles.statsKey}>
              Duration: <span className={styles.statsValue}>1h </span>
            </p>
            <p className={styles.statsDivider}> |</p>
            <p className={styles.statsKey}>
              Author: <span className={styles.statsValue}>{render.user} </span>
            </p>
          </div>
        </div>
        <div className={styles.content}>
          {displayType === 'list' ? (
            images.map((url, index) => {
              const title = url.split('/').pop();
              const result = url;
              if (index % 23 === 0 && index !== 0) {
                return (
                  <div>
                    <Waypoint onEnter={e => this.loadMoreResults(index / 23)} />
                    <RenderReview output={{ title, result }} hideBtn={true} />
                  </div>
                );
              }
              return <RenderReview output={{ title, result }} hideBtn={true} />;
            })
          ) : (
            <Carousel
              data={images.map(url => ({
                title: url.split('/').pop(),
                result: url,
              }))}
              onEnter={this.loadMoreResults}
            />
          )}
        </div>
        <Modal isOpen={modalOpen} style={customStyles}>
          <div className={styles.content}>
            <div className={styles.closeIcon} onClick={this.closeModal} />
            <div className={styles.header}>
              {render.renderType === 'sectional'
                ? 'Upload Sectional Configurator'
                : 'Upload to Scene7'}
            </div>
            <div className={styles.text}>
              Do you want to upload the render images
            </div>
            <div className={styles.btnGroup}>
              <Button text="Yes" onClick={this.submitUploadJob} />
              <Button
                text="No"
                style={{ marginLeft: 30 }}
                onClick={this.closeModal}
              />
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}

export default connect(
  (state, router) => {
    const { id } = router.match.params;
    return {
      results: getResults(state, id),
      number: getNumbers(state, id),
    };
  },
  { getJob, exportImage, getJobResults, uploadScene7, deleteJob }
)(RenderView);



// WEBPACK FOOTER //
// ./src/containers/RenderView/index.js